export var LinkedinStatus;
(function (LinkedinStatus) {
    LinkedinStatus["LINKING"] = "LINKING";
    LinkedinStatus["CODE_REQUIRED"] = "CODE_REQUIRED";
    LinkedinStatus["LINKED"] = "LINKED";
    LinkedinStatus["SYNCING"] = "SYNCING";
    LinkedinStatus["SYNCED"] = "SYNCED";
    LinkedinStatus["ERROR"] = "ERROR";
})(LinkedinStatus || (LinkedinStatus = {}));
//# sourceMappingURL=manfredite-linkedin-sync.interface.js.map